import React from 'react';
import { Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

export const OfflineBanner: React.FC = () => {
  const { t } = useTranslation();
  const isOnline = useNetworkStatus();

  return (
    <Snackbar
      open={!isOnline}
      message={t('pwa.offline')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    />
  );
};
